import React from 'react';
import { View, Text,  StyleSheet, Image as ServerImage } from '../Primitives'
import {Image} from '@react-pdf/renderer'
import dayjs from 'dayjs';

const boxStyle = StyleSheet.create({
    parentBox: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 30,
        marginRight: 30,
        
        
    },
    detailRowContainer: {
        display: 'flex',
       
        flexDirection: 'row',
        margin:5,
    },
    textInclusions: {
        display:'flex',
        flexDirection:'row',
        
    },

    detailColContainer: {
        display: 'flex',
        
        flexDirection: 'column'
    },
    detailColContainerGrey:{
        display: 'flex',
        
        flexDirection: 'column',
        backgroundColor:'#F0F0FA'
    },
    departureContainer: {
        display: 'flex',
        flex: 3,
        flexDirection: 'column'
    },
    departureBox: {
        marginLeft: 30,
        marginRight: 30,
       
        display: 'flex',
        
        flexDirection: 'row'
    },
    departureDetail: {
        display: 'flex',
        flex: 3,
        flexDirection: 'column'
    },
    inclusionsBox: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
    bidHeaderBox: {
        display: 'flex',
        flex: 1,
        padding: 0,
        borderTopStyle:'solid',
        borderTopWidth:2,
        borderTopColor:'orange',
        flexDirection: 'row'
    },
    bidHeaderRank: {
        display: 'flex',
        
        width:50,
        height:50,
        backgroundColor:'orange',
        textAlign:'center',
        color:'white',
        alignItems:'center',
        justifyContent:'center',
        
    },
    rankText: {
        fontSize:25,
    },
    bidHeaderRest: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems:'center',
    },
    


    dateText: {
        fontSize: 15,
        color: '#FFF',
    }, 
    boldText: {
        fontSize: 15,
        paddingRight:15,
        fontFamily:'Helvetica-Bold',
    },
    moneyText: {
        fontSize: 19,
       
    },
    routeBox: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        marginBottom:5,
    },
    routeDetail: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    manifestDetail: {
        display: 'flex',
        flex: 1,
        backgroundColor: '#eceded',
        fontSize: 6,
        flexDirection: 'column',
        padding: 8,
        marginLeft: 0,
        marginBottom: 0,
    },
    routeHeader: {
        fontSize: 16,
        backgroundColor: '#F47820',
        flexDirection: 'row',
        padding: 5,
        color: '#fff',
        
    },
    routeHeaderQg: {
        fontSize: 16,
        backgroundColor: '#006CAA',
        flexDirection: 'row',
        padding: 5,
        color: '#fff',
        
    },
    flexContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-between',
      
    },
    flexBox:{
        display:'flex',
        flex:1,
        marginBottom:0
    }, 
    routeText: {
        display: 'flex',
        flex: 1,
        marginBottom: 0,
        textAlign:'left', 
    }, 
      leftText:{
        fontSize:11,
     
    },
    rightText:{
        fontSize:11,
    },
    departTime:{
        fontSize:12,
    },
    image: {
         width:'auto',
         height:100,
         marginRight:'5',
        marginLeft: '5',
        flex: 1,
        display: 'flex',    
        marginTop: 'auto',
        marginBottom: 'auto',
        maxHeight: 100,
        maxWidth:200,

    },
    crossTick: {
        width:10,
        height:'auto',
        marginRight:'5'

   },
    bodyContainer: {
         
    },
    bodyContainerGrey: {
        marginLeft: 30,
        marginRight: 30,
        marginBottom:30,
        display: 'flex', 
        backgroundColor:'#AAAAAA'   
    },
})


const Bid = ({ charter, bid, includeImages=true }) => {
    let images = {};
    bid.routes.map(x => x?.aircraft?.map(y => y?.images?.map(z => { images[z.id] = z; return null })));
    const img = Object.keys(images).map(x => { return [images[x].contentType, images[x].file].join(",") });
    const minutesOffset = charter.client.itineraryMinutesOffset ? charter.client.itineraryMinutesOffset : 0;
    const price = bid.withMargin > bid.price ? bid.withMargin : bid.price + bid.withMargin;

    return <React.Fragment>
        <View style={boxStyle.parentBox} minPresenceAhead={200}>
            <View style={boxStyle.bidHeaderBox}>
                <View style={boxStyle.bidHeaderRank}>
                    <Text style={boxStyle.rankText}>{bid.rank}</Text>
                </View>
                <View style={boxStyle.bidHeaderRest}>
                    <Text style={boxStyle.boldText}>Operator</Text>
                    <Text>{bid.supplier.companyName}</Text>
                </View>
                <View style={boxStyle.bidHeaderRest}>
                    <Text style={boxStyle.boldText}>Price (EX GST)</Text>
                    <Text>${bid.currency}</Text><Text style={boxStyle.moneyText}>{price}</Text>
                </View>
            </View>
        </View>

        <View style={boxStyle.departureBox} >
            <View style={boxStyle.departureContainer}>
                {bid.routes.map((route, i) => {
                    return <View key={i} style={i % 2 === 1 ? boxStyle.detailColContainer : boxStyle.detailColContainerGrey} minPresenceAhead={170} >
                        <View style={boxStyle.detailRowContainer}>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Departure Date</Text>
                                <Text style={boxStyle.departTime}>{dayjs(route.departTime).subtract(minutesOffset, "minute").format("DD/MMM/YYYY")}</Text>
                            </View>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Departure Time</Text>
                                <Text style={boxStyle.departTime}>{dayjs(route.departTime).subtract(minutesOffset, "minute").format("HH:mm A")}</Text>
                            </View>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Flight Time</Text>
                                <Text style={boxStyle.departTime}>{route.flightTime}</Text>
                            </View>

                        </View>
                        <View style={boxStyle.detailRowContainer}>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Aircraft</Text>
                                <Text style={boxStyle.departTime}>{route.aircraft.map((x, i) => { return x.type + ' ' + x.licenseNumber })}</Text>
                            </View>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Payload</Text>
                                <Text style={boxStyle.departTime}>{route.payload}</Text>
                            </View>
                            <View style={boxStyle.departureDetail}>
                                <Text style={boxStyle.boldText}>Passenger Limit</Text>
                                <Text style={boxStyle.departTime}>{route.passengerLimit}</Text>
                            </View>

                        </View>

                    </View>
                })}
            </View>
            <View style={boxStyle.inclusionsBox}>
                <Text style={boxStyle.boldText}>Inclusions and Exclusions</Text>

                {bid.inclusions ? bid.inclusions.split(',').map((x, i) => <View key={i} style={boxStyle.textInclusions}><ServerImage style={boxStyle.crossTick} src='/img/pdf/Tick.png' /><Text>{x}</Text></View>) : null}
                {bid.exclusions ? bid.exclusions.split(',').map((x, i) => <View key={i} style={boxStyle.textInclusions}><ServerImage style={boxStyle.crossTick} src='/img/pdf/Cross.png' /><Text>{x}</Text></View>) : null}


            </View>
        </View>

        {bid.notes ? <View style={boxStyle.parentBox} minPresenceAhead={100}>
            <Text style={boxStyle.boldText}>Operator Notes</Text>
            <Text style={boxStyle.departTime}>{bid.notes}</Text>
        </View> : null}
        {includeImages && img && img.length ? <View style={boxStyle.parentBox} minPresenceAhead={100} >

            <Text style={boxStyle.boldText}>Aircraft Images</Text>

            <View style={boxStyle.detailRowContainer}>
                {img.map((x, i) => <Image key={i} style={boxStyle.image} src={x} />)}
            </View>

        </View> : null}
    </React.Fragment>
}



export default Bid; 